import React from 'react'

import { useModal } from '@flecto/ui'

import {
  ModalBookingActionRestoreCancel,
  type ModalBookingActionRestoreCancelProps,
} from '../components/ModalBookingActionRestoreCancel/ModalBookingActionRestoreCancel'

export function useModalBookingActionRestoreCancel(
  props: ModalBookingActionRestoreCancelProps
) {
  return useModal(<ModalBookingActionRestoreCancel {...props} />)
}
